import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import * as tus from "tus-js-client";
import {
  currentOrganizationSelector,
  currentUploadingVideosSelector,
  userSelector,
} from "../../store/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useFileDrop } from "../../hooks/useFileDrop";
import {
  addUserToProject,
  createProject,
  createVersion,
  updateVersion,
} from "../../store/projectsSlice";
import { ReactComponent as CloseIcon } from "../../assets/cross-color.svg";
import uploadIcon from "../../assets/upload.svg";
import { useNavigate } from "react-router";
import Avatar from "../Avatar/Avatar";
import "./AddProjectModal.css";
import toast from "react-hot-toast";
import { OrbitProgress } from "react-loading-indicators";
import { setCurrentUploadingVideosInfo } from "../../store/appSlice";
import CloseButton from "../CloseButton/CloseButton";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import useOrganizationLimits from "../../hooks/useOrganizationLimits";

const AddProjectModal = ({
  onClose = () => {},
  onUpdate = () => {},
  parentId = "",
}) => {
  const limits = useOrganizationLimits();
  const [activeTab, setActiveTab] = useState("project");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const user = useSelector(userSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const currentUploadingVideosInfo = useSelector(
    currentUploadingVideosSelector
  );
  const [description, setDescription] = useState("");
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageObjectUrl, setCoverImageObjectUrl] = useState(null);
  const [isVersionUploading, setIsVersionUploading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [versionScreenshot, setVersionScreenshot] = useState(null);
  const [newMemberEmail, setNewMemberEmail] = useState("");
  const [newMemberRole, setNewMemberRole] = useState("Участник");
  const [currentMegabytes, setCurrentMegabytes] = useState(0);
  const [totalMegabytes, setTotalMegabytes] = useState(0);
  const [teamMembers, setTeamMembers] = useState([
    {
      ...user,
      isOwner: true,
    },
  ]);
  const modalRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !isLoading
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleCreateProject = () => {
    setIsLoading(true);
    let formData = new FormData();
    let projectData = {
      title: projectName,
      description,
      organizationId: currentOrganization.id,
    };
    if (!!parentId) {
      projectData = {
        ...projectData,
        parentId,
      };
    }
    formData.append("body", JSON.stringify(projectData));

    if (coverImage) {
      formData.append("file", coverImage);
    }
    dispatch(createProject(formData)).then((res) => {
      if (!res.error) {
        if (selectedFile) {
          handleVersionUpload(selectedFile, res.payload);
        } else {
          setIsLoading(false);
          onClose();
          navigate(`/projects/${res.payload.id}`);
        }
      }
      // return dispatch(
      //   addUserToProject({
      //     projectId: res.payload.id,
      //     userData: { role: "ADMIN", email: user.email },
      //   })
      // .then((userRes) => {
      //   if (selectedFile) {
      //     handleVersionUpload(selectedFile, res.payload);
      //   } else {
      //     setIsLoading(false);
      //     onClose();
      //     navigate(`/projects/${res.payload.id}`);
      //   }
      // });
      else {
        setIsLoading(false);
        const errorText = res.payload;
        toast.error(errorText);
      }
    });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 4096 * 1024 * 1024) {
      // 20MB limit
      setCoverImage(file);
      setCoverImageObjectUrl(URL.createObjectURL(file));
    }
  };

  const onChangeSelectedVideo = (e) => processFile(e.target.files[0]);

  const processFile = (file) => {
    if (!limits) {
      navigate("/pricing");
      return;
    }
    const sizeLimit =
      limits &&
      limits.find((value) => value.attributeCode === "AVAILABLE_SPACE_MB");
    if (sizeLimit) {
      const availableSpace =
        (sizeLimit.maxValue - sizeLimit.usedValue) * 1024 * 1024;

      if (file && availableSpace < file.size) {
        toast.error(
          `Недостаточно места в соответствии с вашим текущим тарифом. Доступно: ${(
            sizeLimit.maxValue - sizeLimit.usedValue
          ).toFixed(2)}МБ`
        );
        return;
      }
    }
    if (file) {
      setSelectedFile(file);
      generateThumbnail(file);
    }
  };

  const { isDragActive, dropHandlers } = useFileDrop({
    onFile: processFile,
    disabled: isLoading,
  });

  const handleVersionUpload = async (file, project) => {
    if (file) {
      let versionData = {
        name: file.name,
        status: "IN_PROGRESS",
      };

      dispatch(createVersion({ projectId: project.id, versionData })).then(
        (res) => {
          if (!res.error) {
            const versionId = res.payload.id;
            let uploads = {};
            const uploadedVideoInfo = {
              file,
              data: res.payload,
              isUploaded: false,
              isCompleted: false,
              parentProjectId: project.id,
            };

            dispatch(
              setCurrentUploadingVideosInfo([
                ...currentUploadingVideosInfo,
                uploadedVideoInfo,
              ])
            );
            onClose();
            setIsLoading(false);
            navigate(`/projects/${project.id}`);
            // let data = res.payload;
            // //let upload_url = "https://" + data.servers[0].hostname + "/upload/";
            // let upload_url =
            //   "https://" + "vod-uploader-2.edgevideo.ru" + "/upload/";

            // uploads[data.video.id] = new tus.Upload(file, {
            //   endpoint: upload_url,
            //   metadata: {
            //     filename: data.video.name,
            //     client_id: data.video.client_id,
            //     video_id: data.video.id,
            //     token: data.token,
            //   },
            //   onProgress: (bytesUploaded, bytesTotal) => {
            //     setCurrentMegabytes(bytesUploaded);
            //     setTotalMegabytes(bytesTotal);
            //   },
            //   onSuccess: function () {
            //     dispatch(
            //       updateVersion({
            //         versionId,
            //         title: file.name,
            //         status: "FINAL",
            //       })
            //     ).then((res) => {
            //       if (!res.error) {
            //         onClose();
            //         setIsLoading(false);
            //         navigate(`/projects/${project.id}`);
            //       } else {
            //         onClose();
            //         setIsLoading(false);
            //         navigate(`/projects/${project.id}`);
            //       }
            //     });
            //   },
            //   onError: function () {
            //     setIsLoading(false);
            //     toast.error("Ошибка загрузки версии");
            //   },
            // });
            // uploads[data.video.id].start();
          } else {
            setIsLoading(false);
            toast.error("Ошибка создания версии");
          }
        }
      );
    }
  };

  const checkVideoProcessing = (videoId) => {
    axios
      .get(`https://api.edgecenter.ru/streaming/vod/videos/${videoId}`, {
        headers: {
          Authorization:
            "APIKey 8560$e031e3dfc0d386b48dfe80e079fec36ee5e37121464fce055da6dce7a9410eff9a446ae8671ef3acfc3aded198580de6e39c21b1ef9d0b237f2122c2bae9fe2d",
        },
      })
      .then((res) => {
        const video = res.data;
        if (video.screenshot) {
          setIsVersionUploading(false);
          setIsProcessing(false);
          setUploadProgress(0);
          setVersionScreenshot(video.screenshot);
        } else {
          setTimeout(() => {
            checkVideoProcessing(videoId);
          }, 3000);
        }
      });
  };

  const generateThumbnail = (file) => {
    const video = document.createElement("video");
    video.preload = "metadata";
    video.src = URL.createObjectURL(file);
    video.muted = true;
    video.playsInline = true;
    video.currentTime = 1;
    video.onloadeddata = () => {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      setThumbnailUrl(canvas.toDataURL("image/png"));
      URL.revokeObjectURL(video.src);
    };
  };

  // Add keyframes for spinner animation
  const spinnerStyle = document.createElement("style");
  spinnerStyle.innerHTML = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(spinnerStyle);

  const renderUploadingState = () => {
    // Calculate progress (0 to 1)
    const progress =
      totalMegabytes && currentMegabytes
        ? Math.min(currentMegabytes / totalMegabytes, 1)
        : 0;

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: 16,
        }}
      >
        {/* Progress bar background */}
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: `${progress * 100}%`,
            background: "#333B4B",
            transition: "width 0.3s",
            zIndex: 1,
          }}
        />
        {/* Overlay content */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <OrbitProgress style={{ fontSize: 8 }} color="#3496FF" />
          <span style={{ color: "#C1C4CB", fontSize: 16, marginTop: 5 }}>
            Загружается
          </span>
          {!!totalMegabytes ? (
            <span style={{ color: "#717B8E", fontSize: 14, marginTop: 5 }}>
              {(currentMegabytes / 1024 / 1024).toFixed(2)}МБ /{" "}
              {(totalMegabytes / 1024 / 1024).toFixed(2)}МБ
            </span>
          ) : (
            <span style={{ color: "#717B8E", fontSize: 14, marginTop: 5 }}>
              Подготовка...
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={modalStyles.overlay}>
      <div className="modal" ref={modalRef}>
        <CloseButton onClose={onClose} />
        <h1 style={modalStyles.title}>
          {!!parentId ? "Добавить новую папку" : "Добавить новый проект"}
        </h1>
        <div style={modalStyles.tabContainer}>
          <button
            className={`addProjectModal-tab-button ${
              activeTab === "project" && "active-tab"
            }`}
            onClick={() => setActiveTab("project")}
          >
            О проекте
          </button>
          <button
            className={`addProjectModal-tab-button ${
              activeTab === "team" && "active-tab"
            }`}
            onClick={() => setActiveTab("team")}
          >
            Команда
          </button>
        </div>
        <div style={modalStyles.contentContainer}>
          {activeTab === "project" && (
            <>
              <textarea
                className="addProjectModal-textarea"
                readOnly={isLoading}
                value={projectName}
                style={{
                  ...modalStyles.input,
                  lineHeight: "20px",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  "::placeholder": {
                    color: "#717B8E",
                  },
                }}
                placeholder={!!parentId ? "Название папки" : "Название проекта"}
                onChange={(e) => setProjectName(e.target.value)}
              />

              {/* <textarea
                style={{
                  ...modalStyles.textarea,
                  "::placeholder": {
                    color: "#4a4f5c",
                  },
                }}
                readOnly={isLoading}
                placeholder="Описание"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              /> */}

              <label style={modalStyles.uploadArea}>
                <input
                  readOnly={isLoading}
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                  disabled={isLoading}
                  style={{ display: "none" }}
                />
                {coverImageObjectUrl ? (
                  <img
                    src={coverImageObjectUrl}
                    alt="Project poster"
                    style={{
                      width: "100%",
                      height: "150px",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <>
                    <div style={modalStyles.uploadText}>Загрузите обложку</div>
                  </>
                )}
              </label>
              <div
                style={{
                  width: "400px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    ...modalStyles.versionUploadArea,
                    ...(isDragActive
                      ? modalStyles.versionUploadAreaActive
                      : {}),
                  }}
                  {...dropHandlers}
                >
                  <input
                    readOnly={isLoading}
                    type="file"
                    accept="video/*"
                    onChange={onChangeSelectedVideo}
                    style={{ display: "none" }}
                    disabled={isLoading}
                  />
                  {isLoading ? (
                    renderUploadingState()
                  ) : thumbnailUrl ? (
                    <img
                      src={thumbnailUrl}
                      alt="Video thumbnail"
                      className="add-version-poster-image"
                      style={{ borderRadius: 16 }}
                    />
                  ) : (
                    <>
                      <img
                        src={uploadIcon}
                        alt="Video thumbnail"
                        style={{ borderRadius: 8, width: 32 }}
                      />
                      <div style={modalStyles.versionUploadText}>
                        Добавьте первую версию
                      </div>
                    </>
                  )}
                </label>
                {!isVersionUploading && !isProcessing && !versionScreenshot && (
                  <div style={modalStyles.versionUploadSubtext}>
                    Загрузите первую видео версию в проект прямо сейчас или
                    сделайте это позже
                  </div>
                )}
                {versionScreenshot && (
                  <div style={modalStyles.versionLabel}>Версия 1</div>
                )}
              </div>
            </>
          )}

          {activeTab === "team" && (
            <div
              style={{
                width: "570px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div style={{ display: "flex", alignItems: "stretch" }}>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    border: "1px solid #333b4b",
                    borderRadius: "80px",
                    overflow: "hidden",
                  }}
                >
                  <input
                    type="email"
                    value={newMemberEmail}
                    onChange={(e) => setNewMemberEmail(e.target.value)}
                    className="addProjectModal-input"
                    placeholder="Введите электронную почту"
                    // style={{
                    //   flex: 1,
                    //   height: "auto",
                    //   padding: "12px 16px",
                    //   backgroundColor: "transparent",
                    //   border: "none",
                    //   color: "#717b8e",
                    //   fontSize: "16px",
                    //   fontWeight: 500,
                    // }}
                  />
                  <div
                    style={{
                      width: "1px",
                      backgroundColor: "#333b4b",
                      margin: "12px 0",
                    }}
                  />
                  <select
                    value={newMemberRole}
                    onChange={(e) => setNewMemberRole(e.target.value)}
                    style={{
                      padding: "12px 16px",
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#717b8e",
                      fontSize: "14px",
                      fontFamily: "NT Somic",
                      fontWeight: 500,
                      cursor: "pointer",
                      appearance: "none",
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%23717b8e' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 12px center",
                      textAlign: "right",
                      paddingRight: "36px",
                      width: "120px",
                      WebkitTapHighlightColor: "transparent",
                      WebkitTouchCallout: "none",
                      WebkitUserSelect: "none",
                      MozUserSelect: "none",
                      msUserSelect: "none",
                      userSelect: "none",
                      outline: "none",
                    }}
                  >
                    <option value="Участник">Участник</option>
                    <option value="Администратор">Админ</option>
                  </select>
                </div>
                <PrimaryButton
                  text="Пригласить"
                  onClick={() => {
                    if (newMemberEmail) {
                      setTeamMembers([
                        ...teamMembers,
                        {
                          id: Date.now(),
                          email: newMemberEmail,
                          role: newMemberRole,
                          avatar: `https://api.dicebear.com/7.x/initials/svg?seed=${Date.now()}`,
                        },
                      ]);
                      setNewMemberEmail("");
                    }
                  }}
                  style={{ marginLeft: "8px", padding: "12px 24px" }}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  maxHeight: "300px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "100%",
                }}
              >
                {teamMembers.map((member) => (
                  <div
                    key={member.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "8px",
                      borderRadius: "8px",
                      width: "100%",
                    }}
                  >
                    <Avatar name={member.email} size={32} />
                    <span
                      style={{
                        flex: 1,
                        color: "#c1c4cb",
                        fontSize: "16px",
                        fontWeight: 500,
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {member.email}
                    </span>
                    <select
                      value={member.role}
                      onChange={(e) => {
                        if (!member.isOwner) {
                          setTeamMembers(
                            teamMembers.map((m) =>
                              m.id === member.id
                                ? { ...m, role: e.target.value }
                                : m
                            )
                          );
                        }
                      }}
                      disabled={member.isOwner}
                      style={{
                        padding: "8px 32px 8px 16px",
                        backgroundColor: "transparent",
                        border: "none",
                        color: member.isOwner ? "#c1c4cb" : "#717b8e",
                        fontSize: "14px",
                        fontWeight: 500,
                        cursor: member.isOwner ? "default" : "pointer",
                        appearance: "none",
                        backgroundImage: member.isOwner
                          ? "none"
                          : `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%23717b8e' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 12px center",
                        flexShrink: 0,
                        WebkitTapHighlightColor: "transparent",
                        WebkitTouchCallout: "none",
                        WebkitUserSelect: "none",
                        MozUserSelect: "none",
                        msUserSelect: "none",
                        userSelect: "none",
                        outline: "none",
                      }}
                    >
                      {member.isOwner ? (
                        <option value="Владелец">Владелец</option>
                      ) : (
                        <>
                          <option value="Участник">Участник</option>
                          <option value="Администратор">Администратор</option>
                          <option value="Зритель">Зритель</option>
                        </>
                      )}
                    </select>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {activeTab === "project" &&
          ((
            <PrimaryButton
              onClick={() => {
                if (!isLoading) {
                  setIsLoading(true);
                  handleCreateProject();
                }
              }}
              isLoading={isLoading}
              text={!!parentId ? "Добавить папку" : "Добавить проект"}
              style={{
                padding: "16px 32px",
                fontSize: 16,
              }}
            />
          ) ||
            null)}
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 101,
  },
  modal: {
    width: "610px",
    backgroundColor: "#1f242e",
    borderRadius: "16px",
    maxHeight: "90%",
    minHeight: "372px",
    padding: "32px",
    position: "relative",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE and Edge */,
    "&::-webkit-scrollbar": {
      /* Chrome, Safari and Opera */ display: "none",
    },
  },
  contentContainer: {
    width: "100%",
    //height: "500px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    color: "#c1c4cb",
    fontSize: "24px",
    fontWeight: 600,
    fontFamily: "NT Somic",
    marginBottom: "32px",
    textAlign: "center",
  },
  tabContainer: {
    display: "flex",
    gap: "4px",
    marginBottom: "24px",
    justifyContent: "center",
    width: "400px",
  },
  tab: {
    padding: "8px 24px",
    borderRadius: "80px",
    border: "1px solid #333b4b",
    backgroundColor: "#1f242e",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "NT Somic",
    cursor: "pointer",
    flex: 1,
    //maxWidth: "130px",
    whiteSpace: "nowrap",
    overflow: "visible",
  },
  activeTab: {
    backgroundColor: "#333b4b",
    color: "#F1F7FF",
  },
  input: {
    width: "400px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#F1F7FF",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    height: "56px",
    minHeight: "56px",
    maxHeight: "56px",
    lineHeight: "1.5",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  textarea: {
    width: "400px",
    height: "100px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    boxSizing: "border-box",
  },
  uploadArea: {
    width: "400px",
    // height: "70px",
    maxHeight: 150,
    minHeight: 70,
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "8px",
    boxSizing: "border-box",
  },
  versionUploadAreaActive: {
    borderColor: "#2563EB",
    backgroundColor: "rgba(37, 99, 235, 0.08)",
  },
  uploadIcon: {
    width: "32px",
    height: "32px",
    background: `url(https://dashboard.codeparrot.ai/api/image/Z9q4RippvFKitUcs/icons-32-2.png)`,
    marginBottom: "8px",
  },
  uploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
  },
  uploadLimit: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
  },
  submitButton: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    ":hover": {
      opacity: 0.9,
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
  submitButtonDisabled: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    opacity: 0.5,
    cursor: "default",
  },
  versionUploadArea: {
    width: "400px",
    height: "144px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "16px",
    boxSizing: "border-box",
  },
  versionUploadIcon: {
    width: "32px",
    height: "32px",
    background: `url(https://dashboard.codeparrot.ai/api/image/Z9q4RippvFKitUcs/icons-32-2.png)`,
    marginBottom: "16px",
  },
  versionUploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    textAlign: "center",
  },
  versionUploadSubtext: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    maxWidth: "400px",
  },
  versionLabel: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginTop: "8px",
  },
  loadingSpinner: {
    width: "32px",
    height: "32px",
    border: "3px solid #333b4b",
    borderTop: "3px solid #e8f2ff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  uploadProgress: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "8px",
  },
  versionThumbnail: {
    width: "100%",
    height: "150px",
    objectFit: "contain",
    borderRadius: "8px",
  },
};

export default AddProjectModal;
